import Color from "./Color";
const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export function generateString(length) {
    let result = '';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}

export function generateId(name){
  return `${name}_${generateString(5)}_${generateString(7)}`;
}

export function map(OldValue, OldMin, OldMax, NewMin, NewMax){
  let OldRange = (OldMax - OldMin)
  if (OldRange == 0)
    return NewMin;
  
  let NewRange = (NewMax - NewMin)  
  return (((OldValue - OldMin) * NewRange) / OldRange) + NewMin
}

export function generateColorByString(s = ""){
  function ctorgb(charcode){
    let r = {r:0,g:0,b:0}

  }

  function extractCodes(s){
    let codes = {
      r:[],
      g:[],
      b:[],
    };
    let ref = 1;
    for (let i = 0; i < s.length; i++) {
      let n = s.charCodeAt(i);
      if(n>122 || n<97){
        n = n%26+97
      }
      n = parseInt(map(n,97,122,0,230));
      ref = ((ref*n)%s.length)%4+1;
      if(ref === 1){
        codes.b.push(n)
      } else if(ref === 2){
        codes.g.push(n)
      } else if(ref === 3){
        codes.r.push(n)
      }
    }
    return codes;
  }

  function convertCodeToColor(codes,s){
    let r = 0;
    if(codes.r.length > 0){
      let div = 0;
      for (let i = 0; i < codes.r.length; i++) {
        r+=(codes.r[i]*(i+1));
        div+=i+1;
      }
      r = r/div;
    }

    let g = 0;
    if(codes.g.length > 0){
      let div = 0;
      for (let i = 0; i < codes.g.length; i++) {
        g+=codes.g[i]*(i+1);
        div+=i+1;
      }
      g = g/div;
    }

    let b = 0;
    if(codes.b.length > 0){
      let div = 0;
      for (let i = 0; i < codes.b.length; i++) {
        b+=codes.b[i]*(i+1);
        div+=i+1;
      }
      b = b/div;
    }

    let v = 0;
    for (let i = 0; i < s.length; i++) {
      v += s.charCodeAt(i)
    }
    v = ((v*2)%900+100).toString().split("").map((c)=>{
      return parseInt(map(parseInt(c),0,9,0,255));
    })
    r = (r+v[0])/2
    g = (g+v[1])/2
    b = (b+v[2])/2

    return new Color(parseInt(r),parseInt(g),parseInt(b));
  }

  let codes = extractCodes(s.toLowerCase());
  let color = convertCodeToColor(codes, s.toLowerCase());
  // console.log(color.getHex());
  
  return color;
}

export function makeid(number){
  return generateString(number)
}